import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import errorHandler from 'Utils/error-handler';

import VerifyEmailFormSchema from './verify-email-form.validation';

import { Space } from 'antd';
import { AlertBox, Button, TextInput } from '@life-line-lab/components-react';

import './verify-email-form.scss';

interface VerifyEmailFormProps {
  status: string;
  onSubmit: (input: {
    email: string
  }) => void;
  afterSuccess?: () => void;
}

const VerifyEmailForm: React.FC<VerifyEmailFormProps> = ({ status, onSubmit, afterSuccess }) => {
  const initialInput = {
    email: '',
  }

  const initialError = {}

  const history = useHistory();
  const { t } = useTranslation();
  const [input, setInput] = useState<any>(initialInput);
  const [error, setError] = useState<any>(initialError);

  useEffect(() => {
    if (status === 'error' && isEmpty(error)) {
      setError({ ...error, general: t('error.resendVerifyEmailError') })
    }

    if (status === 'success') {
      setInput(initialInput);
      if (afterSuccess) afterSuccess();
    }
  }, [status]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setError(initialError);
    setInput({ ...input, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    try {
      const value = VerifyEmailFormSchema.validateSync(input, {
        strict: true,
        abortEarly: true,
        stripUnknown: false
      });

      if (!isEmpty(value))
        onSubmit({ email: input.email });
    }
    catch(err) {
      const { path, value }: any = errorHandler.validation(err);
      setError({ ...error, [path]: t(`${value}`, { field: t(`label.${path}`) }) });

      if (document.querySelector(`input[name=${path}]`)) {
        (document.querySelector(`input[name=${path}]`) as HTMLInputElement).focus();
      }
      else if (document.querySelector(`div[name=${path}]`)) {
        (document.querySelector(`div[name=${path}] input`) as HTMLInputElement).focus();
      }
    }
  }

  return (
    <div className="verify-email-form">
      <form>
      <Space className="verify-email-form--inner" direction="vertical" size="large">
        <AlertBox isFilled={true} text={error.general} />

        <div>
          <TextInput
            isRequired={true}
            label={t('label.email')}
            name="email"
            value={input.email}
            onChange={handleChange}
          />
          <AlertBox text={error.email} />
        </div>

        <div>
          <Button
            isLoading={status === "loading"}
            type="primary"
            label={t('action.continue')}
            size="large"
            onClick={handleSubmit}
          />

          <Button
            type="link"
            label={t('action.backToLogin')}
            onClick={() => history.push('/login')}
          />
        </div>
      </Space>
      </form>
    </div>
  )
}

export default VerifyEmailForm;
